import {
  ArrowLeft,
  ArrowRight2,
  Cross,
  OrderBook,
} from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import { useEffect, useState } from "react";
import Pulse from "../Loader/Pulse";
import { getDeviceSize } from "../../exports/InteractiveUtils";
import ServerRequest from "../../exports/ServerRequest";
import {
  convertNumberToWords,
  getEndDate,
  getTodayDate,
  priceFormat,
} from "../../exports/UtilFunctions";
import { toUpper } from "../../exports/UserAuth";
import { GetCookie } from "../../exports/CookieManagement";
import CustomIconButton from "../Body/CustomChartComponents/CustomIconButton/CustomIconButton";
import SwiftModal from "../CustomComponents/SwiftModal/SwiftModal";
import CustomSelect from "../Body/CustomChartComponents/CustomSelect/CustomSelect";
import { ConfirmationBoxSmart } from "./ConfirmationBox";
import { Alert } from "../Body/CustomChartComponents/CustomAlert/CustomAlert";
import CustomDatePicker from "../CustomComponents/CustomInputDate/CustomDatePicker";
import achButton from "../../assets/icons/achmandate.svg";

const warning_config = {
  Band: true,
  BandColor: "var(--main-blue)",
  BoxColor: "var(--white)",
  TextColor: "var(--text-color)",
  AutoClose: {
    Active: true,
    Line: true,
    LineColor: "var(--main-blue)",
    Time: 3,
  },
};

const DEVICE_SIZE = getDeviceSize();

const Account = ({ customer }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("Fetching your portfolio");
  const [opacityMsg, setOpacityMsg] = useState(true);
  const [accountDetails, setAccountDeails] = useState([]);
  const [mandateDetails, setMandateDeails] = useState([]);
  const [currentStep, setCurrentStep] = useState("Process");
  const [selectedBank, setSelectedBank] = useState({});
  const [amount, setAmount] = useState("100000");
  const [achPopup, setAchPopup] = useState({
    openPopup: false,
    popupLoading: false,
    popupData: [],
    popupLoadingMessage: "Processing transaction",
    popupOpacity: true,
    confirmMessage: "",
    cancelMessage: "",
  });

  const account_token = GetCookie("token");
  const account_code = customer?.account_code;

  const handlePopupClose = () => {
    setAchPopup((p) => ({
      ...p,
      openPopup: false,
      popupData: [],
      popupLoading: false,
    }));
    setCurrentStep("Process");
  };

  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      await Promise.all([fetchClientMasterReport(), fetchClientMandateData()]);
      setLoading(false);
    };

    loadAllData();

    const loadingMessageInterval = setInterval(() => {
      setLoadingMsg((prev) =>
        prev === "Fetching your portfolio"
          ? "It may take some time"
          : "Fetching your portfolio",
      );
    }, 3000);

    const opacityInterval = setInterval(() => {
      setOpacityMsg((prev) => !prev);
    }, 1500);

    return () => {
      clearInterval(loadingMessageInterval);
      clearInterval(opacityInterval);
    };
  }, []);

  useEffect(() => {
    console.log(mandateDetails);
  }, [mandateDetails]);

  async function fetchClientMasterReport() {
    if (!account_code && !account_token) return;

    try {
      const url = !customer
        ? `/nse/get-client-account?token=${account_token}`
        : `/nse/get-client-account?account_code=${account_code}`;

      const res = await ServerRequest({ url, method: "get" });

      setAccountDeails(res.data.report_data);
    } catch (err) {
      console.error(err);
    }
  }

  async function fetchClientMandateData() {
    try {
      const res2 = await ServerRequest({
        url: customer
          ? `/nse/get-mandate-data?account_code=${account_code}`
          : `/nse/get-mandate-data?token=${account_token}`,
        method: "get",
      });
      setMandateDeails(res2.data.report_data);
    } catch (err) {
      console.log(err);
    }
  }

  const account = accountDetails[0] || {};
  const banks = [];

  for (let i = 1; i <= 5; i++) {
    const accountType = account[`account_type_${i}`]?.trim();
    const bankName = account[`bank_name_${i}`]?.trim();
    const defaultFlag = account[`default_bank_flag_${i}`]?.trim();

    // Only push valid bank accounts (non-empty values)
    if (accountType && bankName && defaultFlag) {
      banks.push({
        accountType,
        bankName,
        defaultFlag,
        accountNo: account[`account_no_${i}`],
        ifsc: account[`ifsc_code_${i}`],
        branch: account[`bank_branch_${i}`],
        status: account[`bank_${i}_status`]?.trim(),
      });
    }
  }

  const formattedOptions = banks.map((bank) => ({
    label: (
      <div className="bank-option">
        <div className="bank-name">{bank.bankName}</div>
        <div className="bank-account">{bank.accountNo}</div>
      </div>
    ),
    value: bank.accountNo,
    accountType: bank.accountType,
    ifsc: bank.ifsc,
    bankName: bank.bankName,
  }));

  const defaultValue = formattedOptions[0];

  const priceOptions = [
    { label: "1 Lac", value: "100000" },
    { label: "10 Lac", value: "1000000" },
    { label: "1 Crore", value: "10000000" },
  ];

  useEffect(() => {
    console.log(mandateDetails);
  }, [mandateDetails]);

  const nominees = [];
  for (let i = 1; i <= 3; i++) {
    const name = account[`nominee_${i}_name`]?.trim();
    const relationship = account[`nominee_${i}_relationship`]?.trim();
    const applicable =
      account[`nominee_${i}_applicable`]?.trim() ||
      account[`nominee${i}_applicable`]?.trim();
    const dob = account[`nominee_${i}_dob`]?.trim();
    const guardian = account[`nominee_${i}_guardian`]?.trim();
    const mobile = account[`nominee_${i}_mobile`]?.trim();
    const email = account[`nominee_${i}_email`]?.trim();
    const identityType = account[`nominee_${i}_identity_type`]?.trim();
    const idNumber = account[`nominee_${i}_id_number`]?.trim();
    const minorFlag = account[`nominee_${i}_minor_flag`]?.trim();
    const address =
      account[`nominee_${i}_address1`]?.trim() === "Same as above"
        ? "Same as above"
        : [
            account[`nominee_${i}_address1`]?.trim(),
            account[`nominee_${i}_address2`]?.trim(),
            account[`nominee_${i}_address3`]?.trim(),
            account[`nominee_${i}_city`]?.trim(),
            account[`nominee_${i}_state`]?.trim(),
            account[`nominee_${i}_country`]?.trim(),
            account[`nominee_${i}_pin`]?.trim(),
          ]
            .filter(Boolean) // remove empty values
            .join(", ");

    // Push only if nominee has a name
    if (name) {
      nominees.push({
        name,
        relationship: relationship,
        dob: dob,
        guardian: guardian,
        mobile: mobile,
        email: email,
        identityType: identityType,
        applicable: applicable,
        idNumber: idNumber,
        minorFlag: minorFlag,
        address: address,
      });
    }
  }

  const handleSubmit = async () => {
    setAchPopup((p) => ({ ...p, popupLoading: true }));

    const regdataTemplate = {
      client_code: "",
      amount: "",
      mandate_type: "E",
      account_no: "",
      ac_type: "",
      ifsc_code: "",
      micr_code: "",
      start_date: "",
      end_date: "",
      member_mandate_no: "",
    };

    const today = getTodayDate();
    try {
      if (!selectedBank) return; // make sure something is selected

      const regdata = [
        {
          ...regdataTemplate,
          client_code: account.client_cod,
          amount: amount,
          account_no: selectedBank.value, // now this is correct
          ac_type: selectedBank.accountType,
          ifsc_code: selectedBank.ifsc,
          start_date: today,
          end_date: getEndDate(today),
        },
      ];

      const res = await ServerRequest({
        url: "/nse/mandate-registration",
        method: "post",
        data: {
          regdata,
          bankName: selectedBank.bankName,
          clientData: accountDetails,
        },
      });

      const result = res?.data?.reg_data?.[0];

      const success = result.reg_status === "REG_SUCCESS";
      setCurrentStep("Final");
      if (success) {
        setAchPopup((p) => ({
          ...p,
          confirmMessage: "Success",
          cancelMessage:
            result.reg_remark || "Mandate registration successfull",
        }));
      } else {
        setAchPopup((p) => ({
          ...p,
          confirmMessage: "Failed",
          cancelMessage: result.reg_remark || "Mandate registration Failed",
        }));
      }
    } catch (error) {
      console.log(error);
      setCurrentStep("Final");
      setAchPopup((p) => ({
        ...p,
        confirmMessage: "Failed",
        cancelMessage: "Unexpected internal error occur",
      }));
    } finally {
      setAchPopup((p) => ({ ...p, popupLoading: false }));
    }
  };

  const handleResendLink = async (mandate) => {
    try {
      const res = await ServerRequest({
        url: "/nse//resend-mandate-auth",
        method: "post",
        data: { mandate: mandate, clientData: accountDetails },
      });

      if (res.success) {
        Alert({
          TitleText: "Warning",
          Message: "Authorisation link resend",
          ...warning_config,
        });
      } else {
        Alert({
          TitleText: "Warning",
          Message: "Something went wrong!",
          ...warning_config,
        });
      }
    } catch (error) {
      console.log(error);
      Alert({
        TitleText: "Warning",
        Message: "Something went wrong!",
        ...warning_config,
      });
    }
  };

  return (
    <div className="mf-wrapper">
      {loading ? (
        <div className="app__login__screen">
          <div className="app__login__process">
            <Pulse />
          </div>
        </div>
      ) : (
        <>
          <div
            className={`mf-container ${customer ? "short" : ""} mf-watchlist-container`}
          >
            {accountDetails?.length === 0 && mandateDetails?.length === 0 ? (
              <div className="mf-empty">
                <OrderBook size={40} color={COLOR_VARS["SWIFT_COLOR4"]} />
                <div>
                  <p>No Account found</p>
                  <span>Looks like you haven't added any Mutual Funds yet</span>
                </div>
              </div>
            ) : (
              <>
                <p className="account_heading">Account Details</p>
                <div className="mf_account_card_container">
                  <div className="account_details_cards">
                    <div className="account_card">
                      <p className="account_card_heading">Client Code</p>
                      <p className="account_card_body">{account.client_code}</p>
                    </div>
                    <div className="account_card">
                      <p className="account_card_heading">Holding Nature</p>
                      <p className="account_card_body">
                        {toUpper(account.holding_nature)}
                      </p>
                    </div>
                  </div>
                </div>

                <p className="account_heading">Identity Details</p>
                <div className="mf_identity_card_container">
                  <div className="account_details_cards">
                    <div className="account_card">
                      <p className="account_card_heading">Name</p>
                      <p className="account_card_body">
                        {[
                          toUpper(account.primary_holder_first_name),
                          toUpper(account.primary_holder_middle_name),
                          toUpper(account.primary_holder_last_name),
                        ]
                          .filter((v) => v !== "N/A") // remove empty or N/A
                          .join(" ")}
                      </p>
                    </div>

                    <div className="account_card">
                      <p className="account_card_heading">Date of Birth</p>
                      <p className="account_card_body">
                        {toUpper(account.primary_holder_dob_incorporation)}
                      </p>
                    </div>

                    <div className="account_card">
                      <p className="account_card_heading">PAN</p>
                      <p className="account_card_body">
                        {account.primary_holder_pan}
                      </p>
                    </div>

                    <div className="account_card">
                      <p className="account_card_heading">Gender</p>
                      <p className="account_card_body">
                        {account.gender === " " || ""
                          ? "--"
                          : toUpper(account.gender)}
                      </p>
                    </div>

                    <div className="account_card">
                      <p className="account_card_heading">Tax Status</p>
                      <p className="account_card_body">
                        {toUpper(account.tax_status)}
                      </p>
                    </div>

                    <div className="account_card">
                      <p className="account_card_heading">Guardian</p>
                      <p className="account_card_body">
                        {(() => {
                          const guardianName = [
                            account.guardian_first_name,
                            account.guardian_middle_name,
                            account.guardian_last_name,
                          ]
                            .map((v) => v?.trim()?.toUpperCase())
                            .filter(Boolean) // remove empty
                            .join(" ");

                          return guardianName || "--"; // if no name, show N/A
                        })()}
                      </p>
                    </div>

                    <div className="account_card">
                      <p className="account_card_heading">Email</p>
                      <p className="account_card_body">{account.email}</p>
                    </div>

                    <div className="account_card">
                      <p className="account_card_heading">Mobile</p>
                      <p className="account_card_body">
                        {account.indian_mobile_no}
                      </p>
                    </div>

                    <div className="account_card" style={{ width: "300px" }}>
                      <p className="account_card_heading">Address</p>
                      <p className="account_card_body">
                        {[
                          account.address_1.toUpperCase(),
                          account.address_2.toUpperCase(),
                          account.address_3.toUpperCase(),
                        ]
                          .filter(Boolean)
                          .join(", ")}
                        {[
                          account.city.toUpperCase(),
                          account.state.toUpperCase(),
                          account.country.toUpperCase(),
                        ]
                          .filter(Boolean)
                          .join(", ")}{" "}
                        - {account.pincode || ""}
                      </p>
                    </div>
                  </div>
                </div>

                <p className="account_heading">Bank Details</p>

                <div className="mf_bank_container">
                  {banks.length === 0 ? (
                    <p className="account_card_body">No Bank Accounts Found</p>
                  ) : (
                    banks.map((bank, idx) => (
                      <div className="mf_bank_card_container" key={idx}>
                        <div className="account_details_cards">
                          <div className="account_card">
                            <p className="account_card_heading">Bank</p>
                            <p className="account_card_body">
                              {bank.bankName} ({bank.accountType}){" "}
                              {bank.defaultFlag === "YES" ? "(Default)" : ""}
                            </p>
                          </div>

                          <div className="account_card">
                            <p className="account_card_heading">Account</p>
                            <p className="account_card_body">
                              {bank.accountNo} ({bank.ifsc})
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <p className="account_heading">Mandate Details</p>

                <div className="ach_mandate_button">
                  <div
                    className="hover-btn"
                    onClick={() =>
                      setAchPopup((prev) => ({
                        ...prev,
                        openPopup: true,
                      }))
                    }
                  >
                    Add Mandate{" "}
                  </div>
                </div>

                <div className="mf_bank_container">
                  {mandateDetails.filter(
                    (m) =>
                      m.status === "APPROVED" ||
                      m.status === "UNDER PROCESSING" ||
                      m.status === "PENDING",
                  ).length === 0 ? (
                    <div className="mf_bank_card_container">
                      <div className="account_details_cards">
                        <div className="account_card">
                          <p className="account_card_body">
                            No Mandate Accounts Found
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    mandateDetails
                      .filter(
                        (m) =>
                          m.status === "APPROVED" ||
                          m.status === "UNDER PROCESSING" ||
                          m.status === "PENDING",
                      )
                      .map((mandate, idx) => (
                        <div className="mf_bank_card_container" key={idx}>
                          <div className="account_details_cards">
                            <div className="account_card">
                              <p className="account_card_heading">
                                Bank Account
                              </p>
                              <p className="account_card_body">
                                {mandate.bankName}, Acc. No.{" "}
                                {mandate.bankAccountNumber}
                              </p>
                            </div>
                            <div className="account_card">
                              <p className="account_card_heading">
                                Mandate Details
                              </p>
                              <p className="account_card_body">
                                Amt. {priceFormat(mandate.amount)},{" "}
                                {mandate.status === "PENDING"
                                  ? ""
                                  : `UMRN ${mandate.umrnNo}`}
                              </p>
                              {mandate.status === "PENDING" ? (
                                <p
                                  className="account_card_Link"
                                  onClick={() => handleResendLink(mandate)}
                                >
                                  Resend Link
                                </p>
                              ) : (
                                ""
                              )}
                              {mandate.status === "UNDER PROCESSING" ? (
                                <p className="account_card_Status">
                                  Status : Under Processing
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                  )}
                </div>

                <p className="account_heading">Nominee Details</p>

                <div className="mf_bank_container">
                  {nominees.length === 0 ? (
                    <p className="account_card_body">No Nominees Found</p>
                  ) : (
                    nominees.map((nominee, idx) => (
                      <div className="mf_bank_card_container" key={idx}>
                        <div className="account_details_cards">
                          <div className="account_card">
                            <p className="account_card_heading">
                              {" "}
                              Nominee {convertNumberToWords(idx + 1)}
                            </p>
                            <p className="account_card_body">
                              {toUpper(nominee.name)} (
                              {toUpper(nominee.relationship)})&nbsp; -{" "}
                              {nominee.applicable}%
                            </p>
                          </div>

                          <div className="account_card">
                            <p className="account_card_heading">
                              Date of Birth
                            </p>
                            <p className="account_card_body">{nominee.dob}</p>
                          </div>

                          <div className="account_card">
                            <p className="account_card_heading">Identity</p>
                            <p className="account_card_body">
                              {nominee.identityType} ({nominee.idNumber}){" "}
                            </p>
                          </div>

                          <div className="account_card">
                            <p className="account_card_heading">Contact</p>
                            <p className="account_card_body">
                              {toUpper(nominee.email)} | {nominee.mobile}
                            </p>
                          </div>

                          <div className="account_card">
                            <p className="account_card_heading">Address</p>
                            <p className="account_card_body">
                              {toUpper(nominee.address)}
                            </p>
                          </div>

                          <div className="account_card">
                            <p className="account_card_heading">Minor</p>
                            <p className="account_card_body">
                              {nominee.minorFlag}
                            </p>
                          </div>

                          <div className="account_card">
                            <p className="account_card_heading">Guardian</p>
                            <p className="account_card_body">
                              {(() => {
                                const nomineeGuardian = nominee.guardian
                                  ?.trim()
                                  ?.toUpperCase();
                                return nomineeGuardian || "--";
                              })()}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </>

              // )
            )}
          </div>
        </>
      )}

      {achPopup.openPopup && (
        <SwiftModal closeModal={() => handlePopupClose()} top="2%">
          <div className="swift-mf-popup account">
            {achPopup.popupLoading ? (
              <div className="app__login__screen account">
                <div className="app__login__process">
                  <Pulse />
                </div>
              </div>
            ) : (
              <>
                <div className="swift-mf-popup-body account">
                  <div className="swift-mf-popup-header">
                    <div
                      className="swift-account-svg"
                      onClick={() => {
                        handlePopupClose();
                      }}
                    >
                      {DEVICE_SIZE === "S" ? (
                        <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <p className="swift-mf-popup-name"> ACH Mandate Form </p>
                      {DEVICE_SIZE === "S" ? (
                        ""
                      ) : (
                        <div
                          className="swift-account-svg"
                          onClick={() => handlePopupClose()}
                        >
                          <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="swift-mf-popup-body account">
                    {currentStep === "Process" && (
                      <>
                        <div className="">
                          <div className="swift-mf-popup-text">
                            Select Bank Account
                          </div>
                          <CustomSelect
                            options={formattedOptions.map((opt) => opt.label)}
                            title={"Select Bank Details"}
                            defaultIndex={
                              selectedBank
                                ? formattedOptions.findIndex(
                                    (opt) => opt.value === selectedBank.value,
                                  )
                                : 0
                            }
                            value={
                              formattedOptions.find(
                                (opt) => opt.value === selectedBank?.value,
                              )?.label ||
                              formattedOptions.find(
                                (opt) => opt.value === defaultValue?.value,
                              )?.label
                            }
                            onTypeChange={(label) => {
                              const selected = formattedOptions.find(
                                (opt) => opt.label === label,
                              );
                              setSelectedBank(selected || null); // now stores the full object
                            }}
                            width={200}
                            height={40}
                          />
                        </div>
                        <div className="">
                          <div className="swift-mf-popup-text">
                            Select Amount
                          </div>
                          <CustomSelect
                            options={priceOptions.map((opt) => opt.label)}
                            title={"Select Amount"}
                            defaultIndex={
                              amount
                                ? priceOptions.findIndex(
                                    (opt) => opt.value === amount,
                                  )
                                : 0
                            }
                            value={
                              priceOptions.find((opt) => opt.value === amount)
                                ?.label
                            }
                            onTypeChange={(label) => {
                              const selected = priceOptions.find(
                                (opt) => opt.label === label,
                              );
                              setAmount(selected?.value);
                            }}
                            width={200}
                            height={40}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  {currentStep === "Final" && (
                    <>
                      <div className="swift-mf-account-finalwindow">
                        <ConfirmationBoxSmart
                          confirmMessage={achPopup.confirmMessage}
                          cancelMessage={achPopup.cancelMessage}
                        />
                      </div>
                    </>
                  )}
                </div>

                <div className="step-button account-popup-button">
                  <>
                    <p
                      className="btn-outline"
                      onClick={() => handlePopupClose()}
                    >
                      Back
                    </p>
                    {currentStep === "Process" && (
                      <CustomIconButton
                        title={`Submit`}
                        onClick={() => handleSubmit()}
                      
                      />
                    )}
                  </>
                </div>
              </>
            )}
          </div>
        </SwiftModal>
      )}
    </div>
  );
};

export default Account;
